'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useCallback } from 'react';
import * as NavbarPrimitives from '../primitives';

/**
 * Theme toggle hook
 */
function useThemeToggle() {
  const $ = _c(6);
  const {
    setTheme,
    theme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = () => {
      setTheme(theme === "dark" ? "light" : "dark");
    };
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleThemeToggle = t0;
  let t1;
  if ($[3] !== handleThemeToggle || $[4] !== theme) {
    t1 = {
      handleThemeToggle,
      theme
    };
    $[3] = handleThemeToggle;
    $[4] = theme;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}

/**
 * Theme toggle button for desktop
 */
function ThemeToggle() {
  const $ = _c(3);
  const {
    handleThemeToggle
  } = useThemeToggle();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ThemeToggleIcons />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== handleThemeToggle) {
    t1 = <div><Button variant="outline" size="icon" onClick={handleThemeToggle} aria-label="Toggle theme">{t0}</Button></div>;
    $[1] = handleThemeToggle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
ThemeToggle.displayName = 'NavbarThemeToggle';

/**
 * Theme toggle option for mobile menu
 */
function ThemeToggleOption() {
  const $ = _c(8);
  const {
    theme,
    handleThemeToggle
  } = useThemeToggle();
  let t0;
  if ($[0] !== theme) {
    t0 = <ThemeLabelIcon theme={theme} />;
    $[0] = theme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = theme === "dark" ? "Light Mode" : "Dark Mode";
  let t2;
  if ($[2] !== t1) {
    t2 = <span>{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleThemeToggle || $[5] !== t0 || $[6] !== t2) {
    t3 = <NavbarPrimitives.ActionOption onClick={handleThemeToggle}>{t0}{t2}</NavbarPrimitives.ActionOption>;
    $[4] = handleThemeToggle;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}

/**
 * Animated sun/moon icons
 */
function ThemeToggleIcons() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Moon className="size-4 scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" /><Sun className="absolute size-4 scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

/**
 * Theme icon for dropdown menu label
 */
function ThemeLabelIcon(t0) {
  const $ = _c(2);
  const {
    theme
  } = t0;
  let t1;
  if ($[0] !== theme) {
    t1 = theme === "dark" ? <Sun className="mr-2 h-4 w-4" /> : <Moon className="mr-2 h-4 w-4" />;
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { ThemeToggle, ThemeToggleOption };